<ng-container *ngIf="{ courseId: courseId$ | async } as vm">
  <div [ngClass]="preview ? 'border-r border-r-slate-200 bg-white' : 'bg-slate-100'" class="courses-sidebar flex relative flex-col p-4 pt-0 w-full h-full">
    <div class="menu-items my-6">
      <ul class="text-lg">
        <li>
          <a [class.active]="isActive('intended-learners')" (click)="hideSidebar('/instructor/course/' + vm.courseId + '/intended-learners')">
            <svg-icon src="@assets/images/icons/academic-cap2-light.svg" class="h-5 w-5"></svg-icon><span i18n>Intended
              Learners</span>
          </a>
        </li>
        <li>
          <a [class.active]="isActive('details')" (click)="hideSidebar('/instructor/course/' + vm.courseId + '/details')">
            <svg-icon src="@assets/images/icons/clipboard-document-list-solid-light.svg" class="h-5 w-5"></svg-icon>
            <span i18n>Details</span>
          </a>
        </li>
        <li>
          <a [class.active]="isActive('curriculum')"
            (click)="hideSidebar('/instructor/course/' + vm.courseId + '/curriculum')">
            <svg-icon src="@assets/images/icons/book-solid-light.svg" class="h-5 w-5"></svg-icon><span i18n>Curriculum</span>
          </a>
        </li>
        <li>
          <a [class.active]="isActive('promotions')"
            (click)="hideSidebar('/instructor/course/' + vm.courseId + '/promotions')">
            <svg-icon src="@assets/images/icons/receipt-percent-solid-light.svg" class="h-5 w-5"></svg-icon>
            <span i18n>Promotions</span>
          </a>
        </li>
        <li>
          <a [class.active]="isActive('pricing')" 
            (click)="hideSidebar('/instructor/course/' + vm.courseId + '/pricing')">
            <svg-icon src="@assets/images/icons/tag-solid-light.svg" class="h-5 w-5"></svg-icon>
            <span i18n>Pricing</span>
          </a>
        </li>
        <li>
          <a [class.active]="isActive('tips') || isActiveChild('/instructor/course/'+vm.courseId+'/tips', 5)"
            (click)="hideSidebar('/instructor/course/' + vm.courseId + '/tips')">
            <svg-icon src="@assets/images/icons/bulb-solid-light.svg" class="h-5 w-5"></svg-icon>
            <span i18n>Tips</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="footing mt-auto flex w-full flex-col text-center">
      <div class="menu-items">
        <ul class="text-lg">
          <li>
            <a href="https://support.thkee.com/hc/en-us" target="_blank">
              <svg-icon src="@assets/images/icons/question-mark-circle-border.svg" class="h-5 w-5"></svg-icon>
              <span i18n>Help</span>
            </a>
          </li>
          <li>
            <a [class.active]="isActive('tips')"
              (click)="hideSidebar('/instructor/course/' + vm.courseId + '/settings')">
              <svg-icon src="@assets/images/icons/cog-solid-border.svg" class="h-5 w-5"></svg-icon>
              <span i18n>Settings</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</ng-container>

